import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Layers, Zap, ShieldCheck, TrendingUp } from 'lucide-react';
export function ContextBenefits() {
  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };
  return <section className="w-full pt-0 pb-12 px-6 md:px-12 lg:px-24 bg-white" data-id="element-461">      <div className="max-w-7xl mx-auto" data-id="element-462">
        <div className="text-center mb-16" data-id="element-463">
          
        </div>

        

        <div className="text-center bg-gray-50 rounded-2xl p-8 md:p-12 border border-gray-100" data-id="element-464">
          <p className="text-xl text-gray-800 font-medium mb-8 max-w-4xl mx-auto" data-id="element-465">
            The companies building context graphs now aren't just using AI
            better. They're making their institutional intelligence
            machine-readable—and that's an advantage competitors can't copy.
          </p>

          <Link to="/contact" onClick={scrollToTop} className="inline-flex items-center gap-2 px-8 py-4 bg-[#0066FF] text-white font-['Syne'] font-bold text-sm tracking-wide uppercase hover:bg-black transition-all duration-200" data-id="element-466">
            BUILD YOUR CONTEXT LAYER
            <ArrowRight className="w-5 h-5" data-id="element-467" />
          </Link>
        </div>
      </div>
    </section>;
}
function BenefitCard({
  icon,
  title,
  desc
}: {
  icon: React.ReactNode;
  title: string;
  desc: string;
}) {
  return <div className="bg-white p-8 rounded-xl border border-gray-200 shadow-sm hover:shadow-md transition-all duration-300" data-id="element-468">
      <div className="w-12 h-12 rounded-lg bg-blue-50 flex items-center justify-center text-[#0066FF] mb-6" data-id="element-469">
        {icon}
      </div>
      <h3 className="text-xl font-bold font-['Syne'] text-black mb-4" data-id="element-470">
        {title}
      </h3>
      <p className="text-gray-600 leading-relaxed" data-id="element-471">{desc}</p>
    </div>;
}